import { useField } from 'formik';
import { UserRole } from 'legoland-sdk/dist/experimental';
import { FormGroup, RadioGroup } from 'tombac';
import { ContractType } from "../../contractTypes";
import { jsx as _jsx } from "react/jsx-runtime";
const contractTypeOptions = [{
  label: 'Evaluation',
  value: ContractType.Evaluation
}, {
  label: 'License',
  value: ContractType.License
}, {
  label: 'Distribution',
  value: ContractType.Distribution
}, {
  label: 'Internal',
  value: ContractType.Internal
}];
export const ContractTypeField = ({
  name,
  contract,
  intent,
  userRole,
  ...stylingProps
}) => {
  const [field, meta, helpers] = useField(name);
  const hasUsers = contract.users?.length > 0;
  const value = contractTypeOptions.find(o => o.value === field.value) ?? null;
  return /*#__PURE__*/_jsx(FormGroup, {
    error: meta.touched && meta.error,
    htmlFor: "field-contract-type",
    label: "Contract type",
    required: true,
    ...stylingProps,
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "ContractTypeField",
    "data-sentry-source-file": "ContractTypeField.tsx",
    children: /*#__PURE__*/_jsx(RadioGroup, {
      ...field,
      id: "field-contract-type",
      onChange: option => helpers.setValue(option.value),
      options: userRole === UserRole.Distributor ? contractTypeOptions.filter(el => el.value === ContractType.Evaluation || el.value === ContractType.License) : contractTypeOptions,
      variant: "horizontal",
      value: value,
      disabled: intent !== 'clone' && hasUsers,
      "data-sentry-element": "RadioGroup",
      "data-sentry-source-file": "ContractTypeField.tsx",
      "data-sentry-element": "RadioGroup"
    })
  });
};